import { useCallback, useMemo } from 'react';
import { useLocalStorage } from 'react-use';
import { GridColumnVisibilityModel } from '@mui/x-data-grid';

export const ACTIONS_COLUMN_FIELD = '__actions__';

export const NON_TOGGLABLE_COLUMNS = ['fullName', ACTIONS_COLUMN_FIELD];

const ALWAYS_ON = Object.fromEntries(
  NON_TOGGLABLE_COLUMNS.map((col) => [col, true])
);

type UseColumnVisibilityOptions = {
  storageKey: string;
  defaults: GridColumnVisibilityModel;
};

export const useColumnVisibility = ({
  storageKey,
  defaults,
}: UseColumnVisibilityOptions): [
  GridColumnVisibilityModel,
  (model: GridColumnVisibilityModel) => void,
  () => void
] => {
  const [stored, setStored] = useLocalStorage<GridColumnVisibilityModel>(
    storageKey,
    defaults
  );

  const normalized = useMemo(() => {
    return { ...defaults, ...stored, ...ALWAYS_ON };
  }, [defaults, stored]);

  const set = useCallback(
    (model: GridColumnVisibilityModel) => {
      setStored({ ...defaults, ...model, ...ALWAYS_ON });
    },
    [setStored, defaults]
  );

  const reset = useCallback(() => setStored(defaults), [setStored, defaults]);

  return [normalized, set, reset];
};
